import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FindModel extends Bloc {

	constructor (src, ctx) {

		super("findmodel", src, ctx);
		this.f = (src, ins) => {
			const cardpool = src.master.run.champion.cardpool;
			const cards = ins[0] ? cardpool.filter(ins[0]) : cardpool;
			const item = cards[Math.floor(cards.length * Math.random())];
			return [item, item !== null];
		};
		this.types = [Types.modelfilter];
	}
}